// disable eslint for this file
/* eslint-disable */

import React, { useState } from 'react';
import { Card, Spin, Divider } from 'antd';
import dayjs from '../../utils/dayjs';
import { createSanitizedHTML } from '../../utils/sanitize';
import newsImagePlaceholder from './assets/news-placeholder.png';
import './newsContainer.scss';

const { Meta } = Card;

const imgSrcRe = /src\s*=\s*"(.+?)"/;

function extractThumbnail(content) {
  if (!content) return newsImagePlaceholder;
  const match = imgSrcRe.exec(content);
  return match ? match[1] : newsImagePlaceholder;
}

export function NewsContainer({ title, content, contentSnippet, creator, publishedDate, url }) {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => setLoading(false);

  const handleImageError = (e) => {
    setLoading(false);
    e.target.onerror = null;
    e.target.src = newsImagePlaceholder;
  };

  const date = publishedDate && dayjs(publishedDate).format('YYYY-MM-DD');
  const thumbnail = extractThumbnail(content);
  const descriptionComponent = <div dangerouslySetInnerHTML={createSanitizedHTML(contentSnippet)} />;

  return (
    <Card
      className="news-card"
      hoverable
      onClick={() => window.open(url)}
      cover={
        <Spin spinning={loading}>
          <div className="news-img-container">
            <img alt={title} src={thumbnail} onLoad={handleImageLoad} onError={handleImageError} />
          </div>
        </Spin>
      }
    >
      <Meta title={title} description={descriptionComponent} />
      <Divider />
      <div className="news-detailed">
        <div className="news-detailed-date">
          <i className="fa fa-calendar" />
          {date}
        </div>
        <div className="news-detailed-author">BY {creator || 'LMI Group'}</div>
      </div>
    </Card>
  );
}

export default NewsContainer;
